import axios from 'axios'
import qs from 'qs'
import { Indicator } from 'mint-ui'
import appInfo from 'assets/js/appInfo.js'

// 请求发起前拦截器
axios.interceptors.request.use(
  config => {
    // 全局 loading 状态，触发 loading 效果
    if (config.loading || config.loading === undefined) {
      Indicator.open()
    }

    // 拼接通用的参数
    config.params = {
      'Authorization-AccessToken': appInfo.webAuthToken,
      emoneyToken: appInfo.emoneyToken,
      pd: appInfo.pd,
      mv: appInfo.mv,
      vd: appInfo.vd,
      ar: appInfo.ar,
      ...config.params
    }

    // POST 请求参数处理成 axios post 方法所需的格式
    if (config.method === 'post') {
      config.headers = Object.assign(
        {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        config.headers
      )
      config.data = qs.stringify(config.data)
    }

    // 这句不能省，不然后面的请求就无法成功发起，因为读不到配置参数
    return config
  },
  error => {
    // 异常处理
    Indicator.close()
    return Promise.reject(error)
  }
)

// 响应拦截
axios.interceptors.response.use(
  ({ data, config }) => {
    // 关闭 loading 效果
    if (config.loading || config.loading === undefined) {
      Indicator.close()
      setTimeout(() => Indicator.close(), 600)
    }

    // 这里返回的 response.data 是被 axios 包装过的一成，所以在这里抽取出来
    return data
  },
  error => {
    Indicator.close()
    return Promise.reject(error)
  }
)

// 导出
export default axios



// WEBPACK FOOTER //
// ./src/assets/js/axios.js